import { addMonths } from 'date-fns';

/**
 * Calendar-month arithmetic on a plain `YYYY-MM-DD` date.
 *
 * Repayment deadlines step by calendar months, and the two things that go
 * wrong with that both shipped:
 *
 *   - Adding `months * 30` days, which create_offer did. Calendar months are
 *     not 30 days, so the stored 48-month deadline landed 21 days before the
 *     one the funder was shown.
 *   - `setUTCMonth`, which the browser did. It is calendar-aware but overflows
 *     rather than clamping: Jan 31 + 1 month asks for "Feb 31" and rolls
 *     forward to Mar 3.
 *
 * date-fns `addMonths` clamps to the end of the shorter month, which is the
 * convention here, and gets leap years right without a special case.
 *
 * The Date is built and read entirely in LOCAL components. That looks casual
 * and is deliberate: a funding date is a plain calendar date with no time and
 * no zone, so as long as we never cross into UTC the arithmetic is the same
 * everywhere. Anchoring at an instant instead is what makes a date render a
 * day early for viewers west of the anchor.
 */
export const addCalendarMonths = (isoDate, months) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDate || '').trim());
  if (!match) return null;
  const [, year, month, day] = match;

  const shifted = addMonths(new Date(Number(year), Number(month) - 1, Number(day)), months);

  const yyyy = String(shifted.getFullYear()).padStart(4, '0');
  const mm = String(shifted.getMonth() + 1).padStart(2, '0');
  const dd = String(shifted.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

/** `YYYY-MM-DD` as `MM/DD/YYYY`, with no Date and so no zone to shift it. */
export const formatPlainDate = (isoDate) => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(isoDate || '').trim());
  if (!match) return '';
  const [, year, month, day] = match;
  return `${month}/${day}/${year}`;
};
